import { Configuration, LogLevel } from '@azure/msal-browser'
import { env, removeTrailingSlash } from '../../utilities'

export const msalConfig: Configuration = {
  auth: {
    clientId: env.aadClientId,
    authority: `https://login.microsoftonline.com/${env.aadTenantId}/`,
    redirectUri: new URL(
      `${removeTrailingSlash(env.basePath)}/authorize`,
      `${window.location.protocol}//${window.location.host}`,
    ).href,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}
